import React, {useState} from "react";
import styled from "styled-components";
import * as palette from "../Variables";
import {keyframes} from "styled-components";
import { BrowserRouter, Routes, Route, Link } from 'react-router';

const wiggleAnimation = keyframes`
    0% {transform: rotate(5deg);}
    20% {transform: rotate(-5deg);}
    40% {transform: rotate(4deg);}
    60% {transform: rotate(-3deg);}
    80% {transform: rotate(2deg);}
    100% {transform: rotate(0deg);}
`;

const StyledButton = styled.button`
    padding: 12px 24px;
    border-radius: 8px;
    border: 0;
    background: ${palette.gradientMain};
    background-color: ${palette.pinkMain};
    color: ${palette.neutral1};
    transition: background 250ms ease;
    text-decoration: none;
    display: block;
    font-size: 14px;
    font-weight: 600;

    &:focus {
        background-color: ${palette.orangeMain};
        animation: ${wiggleAnimation} 700ms;
    }

    &:hover {
        background: ${palette.gradient1};
        transition: background 250ms ease;
        cursor: pointer;
        color: ${palette.neutral1};
        animation-name: ${wiggleAnimation};
        animation-duration: 700ms;
    }

    @media (min-width: 768px) {
        font-size: 16px;
    }
`;

const Button = ({text}) => {
    return (
        <StyledButton>
            {text}
        </StyledButton>
    )
}

const StyledButtonLink = styled.div`
    padding: 12px 24px;
    border-radius: 8px;
    border: 0;
    background: ${palette.gradientMain};
    background-color: ${palette.pinkMain};
    color: ${palette.neutral1};
    transition: all 250ms ease;
    text-decoration: none;
    display: inline-block;
    font-size: 14px;
    font-weight: 600;

    a {
        color: ${palette.neutral1};
        text-decoration: none;
        font-weight: 600;
    }

    &:focus {
        background-color: ${palette.orangeMain};
        animation: ${wiggleAnimation} 700ms;
    }

    &:hover {
        background: ${palette.gradient1};
        transition: all 250ms ease;
        cursor: pointer;
        color: ${palette.neutral1};
        animation-name: ${wiggleAnimation};
        animation-duration: 700ms;

        a {
            color: ${palette.neutral1};
            cursor: pointer;
            transition: all 250ms ease;
        }
    }

    @media (min-width: 768px) {
        font-size: 16px;
    }
`;

const ButtonLink = ({to, target, text}) => {
    return (
        <StyledButtonLink>
            <Link to={to} target={target}>{text}</Link>
        </StyledButtonLink>
    )
}

export { Button, ButtonLink };